import { getLicenseTypesOptions } from "@/hera-api/client/@tanstack/react-query.gen";
import { useAuthQuerySetup } from "@/hooks/use-auth-query-setup";
import { filterOperatorLicenseTypes } from "@/lib/license-type-utils";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export function useLicenseTypeFilterOptions() {
  const { isAuthSetupComplete } = useAuthQuerySetup();

  const {
    data: licenseTypesData,
    isLoading,
    error,
  } = useQuery({
    ...getLicenseTypesOptions(),
    enabled: isAuthSetupComplete,
  });

  const operatorLicenseTypes = useMemo(
    () => filterOperatorLicenseTypes(licenseTypesData?.license_types),
    [licenseTypesData?.license_types],
  );

  const licenseTypeOptions = useMemo(
    () =>
      operatorLicenseTypes.map((lt) => ({
        value: lt.id,
        label: lt.under_development
          ? `${lt.name} (Under Development)`
          : lt.name,
      })),
    [operatorLicenseTypes],
  );

  /** Raw license type names — used for column filter options in tables. */
  const licenseTypeNames = useMemo(
    () => operatorLicenseTypes.map((lt) => lt.name),
    [operatorLicenseTypes],
  );

  const licenseTypes = useMemo(
    () => operatorLicenseTypes.map((lt) => ({ id: lt.id, name: lt.name })),
    [operatorLicenseTypes],
  );

  return {
    licenseTypeOptions,
    licenseTypeNames,
    licenseTypes,
    isLoading,
    error,
  };
}
